import Vue from 'vue'

export default {
  state: {
    contentArray: [],
  },
  getters: {
    getContentArray: state => state.contentArray,
  },
  actions: {
    downloadContent: ({commit}, payload) => {
      return Vue.axios.post('translations/getAll', payload).then(response => {
        if(response.status == 200){
          commit('SET_CONTENT_ARRAY', response.data)
        }
        return response
      }).catch(err => {
        return err
      })
    },
    updateContent: ({state}, payload) => {
      console.log('updateContent', payload);
      //ignore these lines, its only to justify having "state" argument
      let nothing = state.contentArray
      console.log(nothing);
      // end ignore

      return Vue.axios.post('translations/update/'+payload.id, payload).then(response => {
        return response
      }).catch(err => {
        return err
      })
    },
  },
  mutations: {
    SET_CONTENT_ARRAY: (state, payload) => {
      state.contentArray = payload
    },
  },
}
